import API, { ListOptions } from "@services/root/rootApi";
import type { AuditFilters, AuditResponse } from "./types";

type GetAuditOptions = ListOptions;

export const getAudit = async (
  filters?: AuditFilters,
  options?: GetAuditOptions
): Promise<AuditResponse> => {
  const { startDate, endDate, ...other } = filters ?? {};
  const { maxResults, orderBy, startIndex } = options ?? {};
  const response = await API.post<AuditResponse>(
    `/symphony-api/audit/search`,
    other,
    {
      params: {
        maxResults,
        startIndex,
        orderBy,
        startDate,
        endDate,
      },
    }
  );
  return response.data;
};
